'use client'

import { usePathname } from 'next/navigation'
import Script from 'next/script'
import React from 'react'
import ReactDOM from 'react-dom'

const CustomScriptsDomains = [
  'https://js.hs-analytics.net',
  'https://api.hubspot.com',
  'https://track.hubspot.com',
  'https://js.hs-banner.com',
  'https://js.hs-scripts.com',
  'https://js.hsadspixel.net',
  'https://connect.facebook.net',
  'https://js.usemessages.com',
  'https://api.hubapi.com',
  'https://www.googletagmanager.com',
  'https://snap.licdn.com',
  'https://analytics.tiktok.com',
]

const Scripts: React.FC = () => {
  for (const domain of CustomScriptsDomains) {
    ;(ReactDOM as any).preconnect(domain)
    ;(ReactDOM as any).prefetchDNS(domain)
  }

  const pathname = usePathname()
  const isBrazaPage = pathname.startsWith('/getbraza')

  return (
    <>
      <noscript>
        <style>
          {`
          .animation-content {
            opacity: 1 !important;
            transform: none !important;
          }
          `}
        </style>
      </noscript>

      <Script
        src="/assets/js/storage-cookie.min.js"
        strategy="afterInteractive"
        id="storage-cookie-script"
      />

      <Script id="google-tag-manager" strategy="lazyOnload">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KZCN8D7V');
        `}
      </Script>

      {isBrazaPage && (
        <>
          <Script id="google-tag-manager-get-braza" strategy="lazyOnload">
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-KZCN8D7V');
            `}
          </Script>

          <Script id="facebook-pixel" strategy="lazyOnload">
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '839459064752822');
              fbq('track', 'PageView');
            `}
          </Script>

          <Script id="tiktok-pixel" strategy="lazyOnload">
            {`
              !function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
            var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
            ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


              ttq.load('CTCNT5BC77U3MQBESA1G');
              ttq.page();
            }(window, document, 'ttq');
            `}
          </Script>

          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src="https://www.facebook.com/tr?id=839459064752822&ev=PageView&noscript=1"
            />
          </noscript>
        </>
      )}
    </>
  )
}

export default Scripts
